import * as actions from "../actions/actions";
import { updateObject } from "../utility";
import { AVAILABLE_PLAYERS } from "../../config/players";

const initialState = {
  theme: "mario-theme",
  players: [],
  availablePlayers: AVAILABLE_PLAYERS,
  gameType: null,
  roundCount: 1,
  isAuth: false,
  isEndGame: false,
  winner: null,
  action: {
    action: "",
    pin: "",
  },
  target: {
    date: null,
    multiple: null,
    value: null,
  },
};

const setAuth = (state, action) => {
  return updateObject(state, {
    isAuth: action.isAuth,
  });
};

const startGame = (state, action) => {
  return updateObject(state, {
    ...action,
  });
};

const resetGame = (state, action) => {
  return updateObject(state, initialState);
};

const buttonPressed = (state, action) => {
  return {
    ...state,
    action: action.data,
  };
};
const targetTouched = (state, action) => {
  return {
    ...state,
    target: { ...action.data },
  };
};

const endGame = (state, action) => {
  return updateObject(state, {
    players: action.players,
    winner: action.winner,
    roundCount: action.roundCount,
    isEndGame: true
  });
};

const setTheme = (state, action) => {
  return {
    ...state,
    theme: action.theme,
  }
}

const updatePlayers = (state, action) => {
  return {
    ...state,
    availablePlayers: action.players,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GAME_AUTH:
      return setAuth(state, action);
    case actions.GAME_START:
      return startGame(state, action);
    case actions.GAME_RESET:
      return resetGame(state, action);
    case actions.GAME_END:
      return endGame(state, action);
    case actions.BUTTON_PRESSED:
      return buttonPressed(state, action);
    case actions.TARGET_TOUCHED:
      return targetTouched(state, action);
    case actions.SET_THEME:
      return setTheme(state, action);
    case actions.UPDATE_PLAYERS:
      return updatePlayers(state, action);
    default:
      return state;
  }
};

export default reducer;
